import { render, staticRenderFns } from "./FoldseekSearchButton.vue?vue&type=template&id=49e97025"
import script from "./FoldseekSearchButton.vue?vue&type=script&lang=js"
export * from "./FoldseekSearchButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports